module.exports = __webpack_public_path__ + "img/nigeria.43fb74b2.png";